import { handleActions } from "redux-actions";

export default handleActions(
  {
    REGIONS_GET: {
      FULFILLED: (state, action) => ({
        regions: action.payload.regions,
      }),
    },
  },
  {},
  { namespace: "_" }
);
